module.exports = __webpack_public_path__ + "static/media/Lesson-11-26-Faith-and-Generosity.14190090.pdf";